<template>
  <div>
    <loading
      name="lp"
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="true"
    ></loading>

    <div class="md-layout">
      <div
        class="md-layout-item md-small-size-100 md-size-50"
        v-if="backpicture"
        :style="{
          'background-image': 'url(' + backpicture + ')',
          'background-size': 'cover',
          opacity: 0.1,
          width: '100%',
          height: '100%',
          position: 'absolute',
        }"
      ></div>
      <div
        class="md-layout-item md-size-100"
        :key="item.id"
        v-for="item in questions"
      >
        <question-item
          :activeonly="1"
          :question="item"
          :ref="item.id"
          :linkid="linkid"
          @changed="changed"
          @deleted="getQuestions"
          @updated="getQuestions"
        ></question-item>
      </div>
    </div>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { GetPublicQuestions } from "../../services/react";
import QuestionItem from "../components/QuestionItem";
export default {
  components: {
    QuestionItem,
    Loading,
  },
  props: {
    linkid: String,
    headerpicture: String,
    backpicture: String,
  },
  data() {
    return {
      questions: [],
      isLoading: false,
    };
  },
  methods: {
    getQuestions() {
      this.isLoading = true;

      GetPublicQuestions(this.linkid).then((response) => {
        if (response.data.result) {
          this.isLoading = false;
          this.questions = response.data.result;
          this.$nextTick(function () {
            this.changed();
          });
        } else {
          this.isLoading = false;
          this.questions = [];
        }
      });
    },
    changed(value) {
      for (var i = 0; i < this.questions.length; i++) {
        if (this.questions[i].rules) {
          let rule = this.questions[i].rules;
          let inirule = this.questions[i].rules;
          for (var k = 0; k < this.questions.length; k++) {
            let v = this.questions[k].orderindex;
            let q = "[" + this.questions[k].orderindex + "]";
            if (inirule.indexOf(q) > -1) {
              let cntrl = this.$refs[this.questions[k].id][0];
              if (cntrl.visible) {
                let val = "";
                if ([5, 6, 8].includes(this.questions[k].answertype)) {
                  val = "[" + cntrl.value().order + "]";
                } else {
                  val = cntrl.value().value;
                }
                var re = new RegExp("\\[" + v + "\\]", "g");
                rule = rule.replace(re, val);
              }
            }
          }
          this.$refs[this.questions[i].id][0].visible = eval(rule);
        }
      }
    },
    validate() {
      let isformvalid = true;
      for (var i = 0; i < this.questions.length; i++) {
        let isvalid = this.$refs[this.questions[i].id][0].visible
          ? this.$refs[this.questions[i].id][0].validate()
          : true;
        if (!isvalid) isformvalid = false;
      }
      return isformvalid;
    },
    value() {
      let vals = [];
      let intarray = [1, 2, 3, 4, 9];
      let answarray = [5, 6, 8];
      for (var i = 0; i < this.questions.length; i++) {
        if (this.$refs[this.questions[i].id][0].visible) {
          let val = this.$refs[this.questions[i].id][0].value();
          if (answarray.includes(this.questions[i].answertype)) {
            for (var k = 0; k < val.value.length; k++) {
              let answer = {};

              answer.linkid = this.linkid;
              answer.questionid = this.questions[i].id;
              answer.valueanswerid = val.value[k];
              vals.push(answer);
            }
          } else {
            val.linkid = this.linkid;
            val.questionid = this.questions[i].id;
            val.comment = val.comment;
            if (intarray.includes(this.questions[i].answertype)) {
              val.valueint = val.value;
            }
            if (this.questions[i].answertype === 7) {
              val.valuetext = val.value;
            }
            vals.push(val);
          }
        }
      }
      return vals;
    },
    isNegative() {
      for (var i = 0; i < this.questions.length; i++) {
        if (this.$refs[this.questions[i].id][0].isNegative()) {
          return true;
        }
      }
      return false;
    },
    commented() {
      for (var i = 0; i < this.questions.length; i++) {
        if (this.$refs[this.questions[i].id][0].visible) {
          if (this.questions[i].answertype === 3) {
            if (this.$refs[this.questions[i].id][0].value().comment) {
              return true;
            }
          }
          if (this.questions[i].answertype === 7) {
            if (this.$refs[this.questions[i].id][0].value().value) {
              return true;
            }
          }
        }
      }
      return false;
    },
  },

  mounted() {
    this.getQuestions();
  },
  watch: {
    linkid() {
      getQuestions();
    },
  },
};
</script>

<style>
</style>